import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/footer/FDEL-TE46.png")